module.exports = __webpack_public_path__ + "static/media/model122.33ce4dbc.glb";